import {flow, get, join, last, map} from 'lodash/fp';

export default (state = {}, {activeRoutes}: any) => {
  const routePath = map(get('name'))(activeRoutes);

  return {
    ...state,
    currentPath: join('.')(routePath),
    currentScreen: last(routePath),
    currentScreenParams: flow([last, get('params')])(activeRoutes),
  };
};
